interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-288">
      <div className="ml" data-id="element-289">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-290">{value}</div>
      <div className="ms" data-id="element-291">{sub}</div>
    </div>;
}